import React, {FC, Fragment} from 'react';

import {Dialog, Transition} from '@headlessui/react';

import {PlatformFeeSettings} from './Components/PlatformFeeSettings';
import {SessionRateSettings} from './Components/SessionRateSettings';

export const PaymentSettingsDrawer: FC<{
  showModal: boolean;
  paymentType: 'platform_fee' | 'session_rate' | undefined;
  closeModal: () => void;
}> = ({showModal, paymentType, closeModal}) => {
  return (
    <Transition.Root show={showModal} as={Fragment}>
      <Dialog as="div" className="relative z-[1000]" onClose={closeModal}>
        <div className="fixed inset-0 bg-gray-400/25" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 bottom-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="w-full pointer-events-auto">
                  <div className="flex w-screen h-screen flex-col overflow-y-scroll bg-white shadow-xl">
                    {paymentType === 'platform_fee' ? (
                      <PlatformFeeSettings onCancel={closeModal} />
                    ) : (
                      <SessionRateSettings onCancel={closeModal} />
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
